import React from "react";
import { Typography } from "@mui/material";
import ConfirmDialog from "../../components/common/ConfirmDialog";

export default function UserDeleteDialog({ open, user, onClose, onConfirm, isDeleting }) {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Kullanıcıyı Sil"
      confirmText="Sil"
      cancelText="Vazgeç"
      confirmVariant="error"
      loading={isDeleting}
      loadingText="Siliniyor..."
      message={
        user ? (
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            <strong>{user.name} {user.surname}</strong> kullanıcısını kalıcı olarak silmek istediğinize emin misiniz? Bu işlem geri alınamaz.
          </Typography>
        ) : null
      }
    />
  );
}
